import {
  ApiResponse,
  Event,
  Incident,
  OccursAction,
} from '@collector/sportsapi-types'

import { HttpClient } from '../../../httpClient.js'

export async function post(
  httpClient: HttpClient,
  eventId: Event['id'],
  incidentId: Incident['id'],
  action: OccursAction,
): Promise<ApiResponse<{ message: string; status: number }>> {
  return httpClient
    .url(`/events/${eventId}/incidents/${incidentId}/occurs/${action}`)
    .post()
    .json()
}
